import React from 'react';
import { Result, Button } from 'antd';
import { ReloadOutlined, HomeOutlined } from '@ant-design/icons';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('Application Error Boundary caught an error:', error, errorInfo);
    
    // You can also log the error to an error reporting service here
    // e.g., Sentry, LogRocket, etc.
    
    this.setState({
      error,
      errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  }

  handleGoHome = () => {
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          minHeight: '100vh', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          background: '#f0f2f5'
        }}>
          <Result
            status="error"
            title="Something went wrong"
            subTitle="We're sorry for the inconvenience. The application encountered an unexpected error."
            extra={[
              <Button 
                type="primary" 
                key="reload"
                icon={<ReloadOutlined />}
                onClick={this.handleReload}
              >
                Reload Application
              </Button>,
              <Button 
                key="home"
                icon={<HomeOutlined />}
                onClick={this.handleGoHome}
              >
                Go to Home
              </Button>,
            ]}
          >
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{ 
                marginTop: '20px',
                textAlign: 'left',
                maxWidth: '800px',
                margin: '20px auto'
              }}>
                <summary style={{ 
                  cursor: 'pointer', 
                  fontWeight: 'bold',
                  marginBottom: '10px'
                }}>
                  Error Details (Development Only)
                </summary>
                <div style={{ 
                  background: '#ffffff', 
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  padding: '16px',
                  overflow: 'auto'
                }}>
                  <div style={{ marginBottom: '16px' }}>
                    <strong>Error Message:</strong>
                    <pre style={{ 
                      background: '#f5f5f5', 
                      padding: '8px', 
                      marginTop: '8px',
                      fontSize: '12px',
                      borderRadius: '4px',
                      overflow: 'auto'
                    }}>
                      {this.state.error.toString()}
                    </pre>
                  </div>
                  {this.state.errorInfo && (
                    <div>
                      <strong>Component Stack:</strong>
                      <pre style={{ 
                        background: '#f5f5f5', 
                        padding: '8px', 
                        marginTop: '8px',
                        fontSize: '12px',
                        borderRadius: '4px',
                        overflow: 'auto',
                        maxHeight: '400px'
                      }}>
                        {this.state.errorInfo.componentStack}
                      </pre>
                    </div>
                  )}
                </div>
              </details>
            )}
          </Result>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

